import './styles/playerscomponent.css'
import { useEffect, useState } from 'react'

//Components
import Loader from './loader'

//Extras
import { IoMdClose } from "react-icons/io"
import { fontType } from '../assets/extras'
import { collection, doc, getDocs, orderBy, query } from 'firebase/firestore'
import { db } from '../assets/connections'

const PlayersComponent = ({reference, addPlayer, showModal, setShowModal}) => {

    const [ variables, setVariables ] = useState({
        loading: false,
        searchP: "",
        allPlayers: []
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Funcion que ontiene a todos los jugadores
    const getPlayers = async () => {
        await getDocs(query(collection(doc(db, reference), "Jugador"), orderBy("nombre_jugador"))).then(players => {
            var aux = []
            
            players.docs.map((v, i) => {
                aux.push({
                    id: v.id,
                    nombre_jugador: v.data().nombre_jugador
                })
            })

            setVariables(prev => ({
                ...prev,
                loading: false,
                allPlayers: aux
            }))

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        getPlayers()
    }, [])

    return (
        <div className='mainPlayersComponent' style={{
            opacity: showModal ? 1 : 0,
            zIndex: showModal ? 1 : -1000
        }}>
            <div className='playersCont'>
                {
                    variables.loading ?
                        <Loader loading={variables.loading} />
                    :
                        <div style={{
                            width: "100%"
                        }}>
                            <div style={{
                                width: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "flex-end",
                                marginBottom: 20
                            }}>
                                <IoMdClose id='outplayer' size={20} color='#C00' onClick={() => setShowModal(false)} style={{
                                    cursor: "pointer"
                                }} />
                            </div>

                            <p style={{
                                textAlign: "center",
                                fontFamily: fontType.title,
                                fontSize: 30
                            }}>JUGADORES</p>

                            <div className='contInput' style={{
                                marginBottom: 20
                            }}>
                                <input
                                    placeholder='Buscar jugador'
                                    style={{
                                        fontFamily: fontType.text,
                                        fontWeight: "lighter"
                                    }}
                                    value={variables.searchP}
                                    onChange={e => {
                                        const t = e.target.value

                                        setVariables(prev => ({
                                            ...prev,
                                            searchP: t
                                        }))
                                    }}
                                />
                            </div>

                            <div className='contPlayers'>
                                {
                                    !variables.searchP ?
                                        variables.allPlayers.map((v, i) => {
                                            return (
                                                <div className='player' onClick={() => addPlayer(v)}>
                                                    <p style={{
                                                        fontFamily: fontType.text,
                                                        fontWeight: "bold"
                                                    }}>{v.nombre_jugador}</p>
                                                </div>
                                            )
                                        })
                                    : 
                                    variables.allPlayers.filter(v => v.nombre_jugador.trim().toLowerCase().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize().match(variables.searchP.trim().toLowerCase().normalize("NFD").replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1").normalize())).map((v, i) => {
                                        return (
                                            <div className='player' onClick={() => addPlayer(v)}>
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    fontWeight: "bold"
                                                }}>{v.nombre_jugador}</p>
                                            </div>
                                        )
                                    })
                                }
                            </div>

                        </div>
                }
            </div>
        </div>
    )
}

export default PlayersComponent